module.exports = __webpack_public_path__ + "img/logo_sowos_pocket_white.326498a9.svg";